import { ExternalLink } from "lucide-react";

function formatDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

function Block({ label, text }) {
  if (!text) return null;
  return (
    <div>
      <div className="text-[10px] font-mono-alt tracking-[0.18em] uppercase text-white/40">{label}</div>
      <p className="mt-1.5 text-sm text-white/75 leading-relaxed whitespace-pre-line">{text}</p>
    </div>
  );
}

export default function IntelligenceCard({ item }) {
  return (
    <article className="border border-white/10 bg-[#0C0E13] p-6 md:p-8" data-testid={`intel-item-${item.item_id}`}>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-[11px] font-mono-alt tracking-[0.14em] uppercase text-white/50">
        <span>{formatDate(item.published_date)}</span>
        <span className="text-white/25">·</span>
        <span className="text-white/70">{item.source_org}</span>
        {item.status === "Draft" && <span className="border border-amber-500/40 text-amber-300 px-2 py-0.5">Draft</span>}
      </div>
      <h3 className="mt-3 font-display text-2xl leading-tight">{item.headline}</h3>
      {item.summary && <p className="mt-3 text-white/70 leading-relaxed">{item.summary}</p>}
      <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-6">
        <Block label="What changed?" text={item.what_changed} />
        <Block label="Why does this matter?" text={item.why_it_matters} />
        <Block label="Who may be affected?" text={item.who_affected} />
      </div>
      {item.relevance_tags?.length > 0 && (
        <div className="mt-6 flex flex-wrap gap-2">
          {item.relevance_tags.map((t) => (
            <span key={t} className="border border-emerald-500/30 bg-emerald-500/[0.06] text-emerald-300 px-2.5 py-1 text-[10px] font-mono-alt tracking-[0.14em] uppercase">{t}</span>
          ))}
        </div>
      )}
      {item.commentary && (
        <div className="mt-6 border-l border-white/20 pl-5">
          <div className="text-[10px] font-mono-alt tracking-[0.18em] uppercase text-emerald-400">PFAS Risk Intelligence commentary</div>
          <p className="mt-2 text-sm text-white/80 leading-relaxed whitespace-pre-line">{item.commentary}</p>
        </div>
      )}
      {item.source_url && (
        <a href={item.source_url} target="_blank" rel="noopener noreferrer" data-testid={`intel-source-${item.item_id}`}
          className="mt-6 inline-flex items-center gap-2 text-[11px] font-mono-alt tracking-[0.18em] uppercase text-white/70 hover:text-white">
          Original source <ExternalLink className="w-3.5 h-3.5" />
        </a>
      )}
    </article>
  );
}
